import { render, staticRenderFns } from "./OppregWorkloadStep2New.vue?vue&type=template&id=37245c74&scoped=true&"
import script from "./OppregWorkloadStep2New.vue?vue&type=script&lang=js&"
export * from "./OppregWorkloadStep2New.vue?vue&type=script&lang=js&"
import style0 from "./OppregWorkloadStep2New.vue?vue&type=style&index=0&id=37245c74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37245c74",
  null
  
)

export default component.exports